module.exports = __webpack_public_path__ + "dashboard/img/return.faf58877d97f52ef436d476886966623.svg";